import React from 'react'
import cn from 'classnames'
import Link from 'redux-first-router-link'
import { LOGIN_PAGE } from 'constants/pages'
import styles from './styles.less'

const Variant3 = ({ page, children }) => {
  return (
    <>
      <div className={cn(styles.Onboarding)}>
        <section
          className={cn(
            styles.Onboarding_Main,
            styles['Onboarding_MainContent-fixedWidth']
          )}
        >
          <div className={styles.Onboarding_Login}>
            Already have an account?{' '}
            <Link to={{ type: LOGIN_PAGE }}>Log in</Link>
          </div>
          <div className={styles['Onboarding_MainContent-fixedWidth']}>
            <div
              key={page}
              className={styles['Onboarding_MainContent-fixedWidth']}
            >
              <div className={styles.Onboarding_MainContent}>
                <div className={styles.Onboarding_Logo}>GrooveHQ</div>
                <div className={styles.Onboarding_InnerContent}>{children}</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Variant3
